import type { GeologyType } from '~/apollo/generated/v4/graphql';
import type { KeyParametersPanelProps as KPPanelProps } from '~/components/key-parameters/key-parameters-panel-v4';
import { CombinedView } from '~/components/key-parameters/key-parameters-panel-v4/combined-view';
import { OCAdditionalFieldsDisplay } from '~/components/key-parameters/key-parameters-panel-v4/oc-additional-fields';
import { TabularView } from '~/components/key-parameters/key-parameters-panel-v4/tabular-view';
import type { OCAdditionalFields } from '~/utils/modules/outcrop-v4';

type Props = {
  geologyType: GeologyType;
  keyParameters: KPPanelProps['keyParameters'];
  outcrop?: OCAdditionalFields;
  leftColMd: number;
  rightColMd: number;
  view?: 'table' | 'combined';
};

export function GeologyTypeTab({
  geologyType,
  keyParameters,
  outcrop,
  leftColMd,
  rightColMd,
  view = 'combined',
}: Props) {
  return (
    <>
      <div>
        {view === 'table' && (
          <TabularView
            geologyType={geologyType}
            keyParameters={keyParameters}
          />
        )}

        {view === 'combined' && (
          <CombinedView
            geologyType={geologyType}
            keyParameters={keyParameters}
            leftColMd={leftColMd}
            rightColMd={rightColMd}
          />
        )}
      </div>

      {outcrop && geologyType && (
        <OCAdditionalFieldsDisplay
          geologyType={geologyType}
          outcrop={outcrop}
          keyParameters={keyParameters}
          leftColMd={leftColMd}
          rightColMd={rightColMd}
        />
      )}
    </>
  );
}
